<div class="snackbar-content">
    <span class="message">{{ data }}</span>
    <button mat-icon-button class="close-button" (click)="snackBarRef.dismissWithAction()">
        <mat-icon>close</mat-icon>
    </button>
</div>